export type CobInfo = {
  otherInsuranceSource: string;
  groupNumber: string;
  additionalInsurance: Array<AdditionalInfo>;
  medicare: Array<MedicareInfo>;
};

export type AdditionalInfo = {
  member: MemberInfo;
  subscriber: SubscriberInfo;
  insuranceCarrier: string;
  groupNumber: string;
  effectiveDate: string;
  cancelDate: string;
  policyNumber: string;
  relationshipToSubscriber: string;
  employmentStatus: string;
  retirementDate: string;
  custody: string;
  parentWithPrimaryMedicalResponsibility: string;
  dependentInformationCourtOrder: string;
  hasAdditionalInsurance: string;
};

export type MemberInfo = {
  firstName: string;
  lastName: string;
  suffix: string;
  gender: string;
  dateOfBirth: string;
};

export type SubscriberDetails = {
  firstName: string;
  lastName: string;
  suffix: string;
  gender: string;
  dateOfBirth: string;
};

export type SubscriberInfo = {
  member: SubscriberMemberInfo;
};

export type SubscriberMemberInfo = {
  firstName: string;
  lastName: string;
  suffix: string;
  gender: string;
  dateOfBirth: string;
};

export type MedicareInfo = {
  member: MemberInfo;
  claimNumber: string;
  eligibilityCriteria: string;
  disabilityBeginDate: string;
  socialSecurityDisabilityIncome: string;
  socialSecurityDisabilityIncomeStartDate: string;
  socialSecurityDisabilityIncomeEndDate: string;
  partACoverage: string;
  partAEffectiveDate: string;
  partACancelDate: string;
  partBCoverage: string;
  partBEffectiveDate: string;
  partBCancelDate: string;
  partCCoverage: string;
  partCCarrierName: string;
  partCPolicyNumber: string;
  partCGroupNumber: string;
  partCEffectiveDate: string;
  partCCancelDate: string;
  partDCoverage: string;
  partDCarrierName: string;
  partDPolicyNumber: string;
  partDGroupNumber: string;
  partDEffectiveDate: string;
  partDCancelDate: string;
  bin: string;
  pcn: string;
  hasMedicare: string;
};

export type DependentInfo = {
  firstName: string;
  lastName: string;
  pin: string;
  gender: string;
  dateOfBirth: string;
  relationship?: string;
};

export enum FORM_TYPE {
  MEDICATION = 'Medication Exception Request Form',
  STEP_THERAPY = 'Step Therapy Exception Request Form',
  DENTAL = 'Member Submitted Dental Claim Form',
  DIRECT_REIMBURSEMENT = 'Direct Reimbursement Claim Form',
}

export enum COB_API_TYPE {
  OTHER_INSURANCE = 'otherinsurance',
  MEDICARE_INSURANCE = 'medicareinsurance',
}

export type Demographic = {
  demographics: {
    firstName: string;
    lastName: string;
    gender: string;
    dateOfBirth: string;
    memberId: string;
    pin: string;
    relationship: string;
    ecId: string;
    address: {
      type: string;
      line1: string;
      line2: string;
      line3: string;
      line4: string;
      city: string;
      state: string;
      postalCode: string;
      countryCode: string;
      county: string;
    };
    contactPoints: [
      {
        type: string;
        use: string;
        value: string;
      },
    ];
    dependents: [
      {
        firstName: string;
        lastName: string;
        gender: string;
        dateOfBirth: string;
        pin: string;
        relationship: string;
        ecId: string;
      },
    ];
    csPhoneNumber: string;
  };
};
